<template>
  <div>
    <base-list-table :hideHeader="true" :loading="loading" :item="data" :total="total" :usePaging="false">
      <template slot-scope="{ item }">
        <td>
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-row no-gutters>
                <v-col cols="12" md="4">
                  <v-list-item class="px-0">
                    <v-list-item-avatar color="blue">
                      <v-icon dark>mdi-google-classroom</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content class="py-0 px-1">
                      <p class="caption grey--text">
                        Nama Kelompok KP
                      </p>
                      <span class="body-1"> {{ $getDeepObj(item, 'nama') || '-' }} </span>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" md="3">
                  <v-list-item class="px-0">
                    <v-list-item-content class="py-0">
                      <v-list-item-title>
                        <v-label color="caption"><small>Nama Kegiatan </small></v-label>
                      </v-list-item-title>
                      <div class="link black--text body-2">
                        {{ $getDeepObj(item, 'm_lokakarya_kegiatan_psp.keterangan') || '-' }}
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" md="2">
                  <v-list-item class="px-0">
                    <v-list-item-content class="py-0">
                      <v-list-item-title>
                        <v-label color="caption"><small> Status </small></v-label>
                      </v-list-item-title>
                      <v-list-item-subtitle class="link black--text body-2">
                        <v-chip dark :color="Number(item.is_lengkap) === 1 ? 'success' : 'orange'">
                          {{ Number(item.is_lengkap) === 1 ? 'Sudah Lengkap' : 'Belum Lengkap' }}
                        </v-chip>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" md="2">
                  <v-list-item class="px-0">
                    <v-list-item-content class="py-0">
                      <v-list-item-title>
                        <v-label color="caption"><small>Aksi</small></v-label>
                      </v-list-item-title>
                      <v-list-item-subtitle class="link black--text body-2">
                        <template v-if="false">
                          <div>
                            <v-btn small color="primary">
                              <v-icon left>mdi-account-group</v-icon>
                              Penugasan
                            </v-btn>
                          </div>
                          <div class="my-1">
                            <v-btn small color="primary">
                              <v-icon left>mdi-file</v-icon>
                              Laporan PA
                            </v-btn>
                          </div>
                        </template>
                        <div>
                          <v-btn small color="primary" @click="$emit('detail', item)">
                            <v-icon left>mdi-eye</v-icon>
                            Lihat Detail
                          </v-btn>
                        </div>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-list-item-content>
            <v-list-item-action-text>
              <base-list-action :data="item" :actions="actions" :allow="allow" @action="$emit('action')" />
            </v-list-item-action-text>
          </v-list-item>
        </td>
      </template>
    </base-list-table>
  </div>
</template>

<script>
import BaseListTable from '@/components/base/BaseListTable';
import BaseListAction from '@/components/base/BaseListAction';
export default {
  name: 'KpLokakarya',
  components: { BaseListTable, BaseListAction },
  props: {
    data: {
      type: [Array, Object],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    total: {
      type: [String, Number],
    },
    actions: {
      type: Array,
    },
    allow: {
      type: Function,
    },
  },
};
</script>

<style scoped></style>
